import commonTracking from 'common/src/client/redux-listeners/common.tracking';
import registrationTracking from './registration.tracking';

export default addListener => {
  commonTracking(addListener);
  registrationTracking(addListener);
};
